import React from 'react';

import clsx from 'clsx';
import { Grid } from '@material-ui/core';
import { MehIcon } from '../../../../../icon/regular';
import { MehIcon as MehSolid } from '../../../../../icon/solid';
import useStyles from './styles';
import { Mood } from './types';

const PartiallyUsefulRecordAction = ({ mood }: Mood) => {
  const classes = useStyles();
  const isActive = mood === 'useful';
  return (
    <Grid item className={clsx(classes.container, isActive && 'active')}>
      {
        mood
          ? isActive
            ? <MehSolid className={clsx(classes.icon, classes.partiallyIcon)} />
            : <MehIcon className={classes.icon} />
          : <MehIcon className={clsx(classes.icon, classes.partiallyIcon)} />
      }
      Partially useful
    </Grid>
  );
};

export default PartiallyUsefulRecordAction;
